import { ICellRendererParams } from 'ag-grid-enterprise';
import React from 'react';

// Implementation lifted to Visualization/getFormattedValue (2026-08-22)
// so non-ScenarioManager surfaces can format FormatKey values; re-exported
// here to preserve this module's existing import surface.
import { getFormattedValue } from '../../../Visualization/getFormattedValue';
import OverflowTooltip from '../../../shared/OverflowTooltip';

export { getFormattedValue };

const ValuesCellRenderer = (
  params: ICellRendererParams & {
    formatKey: number;
  }
) => {
  return (
    <OverflowTooltip
      value={getFormattedValue(params.value, params.formatKey)}
    />
  );
};

export default ValuesCellRenderer;
